<script setup lang="ts">
import { Roles } from '@/constants'
import feedbacksHttpService from '@/services/http/feedbacksHttpService'
import type { FeedbacksAdminModel } from '@/services/http/httpResponses'
import { isNullOrEmpty } from '@raildev/shared-utils'
import { computed, ref } from 'vue'

definePage({
  meta: {
    allowedRoles: [Roles.Admin],
  },
})

const feedbacksResponse = await feedbacksHttpService.getFeedbacks()

const feedbacks = ref<FeedbacksAdminModel[]>(feedbacksResponse.feedbacks)
const formattedFeedbacks = computed(() => {
  return feedbacks.value.map((feedback, index) => ({
    ...feedback,
    order: index + 1,
    comment: isNullOrEmpty(feedback.comment) ? '-' : feedback.comment,
    email: feedback.email ?? '-',
    phoneNumber: feedback.phoneNumber ?? '-',
    createdAt: feedback.createdAt.toLocaleDateString('ru-RU'),
  }))
})
</script>
<template>
  <section class="flex flex-col w-full">
    <DataTable
      :value="formattedFeedbacks"
      scrollable
      scrollHeight="80vh"
      :pt="{ emptyMessageCell: formattedFeedbacks.length < 1 ? 'border-none py-12' : '' }"
    >
      <Column field="order" header="№" />
      <Column field="userName" header="Имя пользователя" />
      <Column field="phoneNumber" header="Телефон" />
      <Column field="email" header="Почта" />
      <Column
        field="rating"
        header="Рейтинг"
        sortable
        :pt="{
          headerCell: ({ context }) => (context.sorted ? 'bg-blue-50 text-blue-700' : ''),
          sortIcon: ({ context }) => (context.sorted ? 'text-blue-700' : ''),
        }"
      />
      <Column field="comment" header="Сообщение" />
      <Column
        field="createdAt"
        header="Дата создания"
        sortable
        :pt="{
          headerCell: ({ context }) => (context.sorted ? 'bg-blue-50 text-blue-700' : ''),
          sortIcon: ({ context }) => (context.sorted ? 'text-blue-700' : ''),
        }"
      />
      <template #empty>
        <div class="flex flex-col gap-4 items-center">
          <span class="pi pi-search text-6xl" />
          <h3 class="font-medium">Данные об отзывах не найдены</h3>
        </div>
      </template>
    </DataTable>
  </section>
</template>
<style scoped></style>
